"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var stack = [];
var listeners = [];
var rendering = false;
/**
 * Adding listener for custom elements render event.
 */
function addRenderListener(listener) {
    listeners.push(listener);
}
exports.addRenderListener = addRenderListener;
/**
 * Remove listener for custom elements render event.
 */
function removeRenderListener(listener) {
    var index = listeners.indexOf(listener);
    /* istanbul ignore else */
    if (index > -1) {
        listeners.splice(index, 1);
    }
}
exports.removeRenderListener = removeRenderListener;
/**
 * This function is used to avoid multiple rendering of component.
 * If parent component is rendering subcomponent, this component will be rendered after parent component rendering ends
 * We can't use debounce based on setTimeout because we need to render components synchronously.
 * @param element
 */
function queuedRender(element) {
    if (!rendering) {
        rendering = true;
        stack.push(element);
        try {
            var _loop_1 = function () {
                var currentElement = stack.shift();
                var toRender = currentElement.renderCallback && currentElement.renderCallback();
                if (toRender !== null && toRender !== undefined) {
                    if (typeof toRender === 'boolean') {
                        // remove nodes when boolean is returned
                        currentElement.render((function () { }));
                    }
                    else {
                        currentElement.render(toRender);
                    }
                    if (currentElement.renderedCallback) {
                        currentElement.renderedCallback();
                    }
                    // if null or undefined is returned then do nothing
                    // so nothing will happen for prerendered element which hasn't recieved its props yet
                }
                listeners.forEach(function (l) { return l(currentElement); });
            };
            while (stack.length > 0) {
                _loop_1();
            }
        }
        finally {
            rendering = false;
        }
    }
    else {
        var index = stack.indexOf(element);
        if (index > -1) {
            stack.splice(index, 1);
        }
        stack.unshift(element);
    }
}
exports.queuedRender = queuedRender;
